import React, { useCallback, useEffect, useState } from 'react';
import { ShoppingCartIcon, XIcon } from 'lucide-react';
const NAMES = ['María', 'Ana', 'Carolina', 'Florencia', 'Julieta', 'Daniela', 'Paula', 'Romina', 'Gabriela', 'Natalia', 'Lucía', 'Agustina', 'Micaela', 'Celeste', 'Alejandra', 'Soledad', 'Verónica', 'Belén', 'Camila', 'Valentina'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Entre Ríos', 'Salta', 'Misiones', 'Chaco', 'Corrientes', 'San Juan', 'Jujuy', 'Río Negro', 'Neuquén', 'La Pampa'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomInterval() {
  return Math.floor(Math.random() * 4000) + 8000;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [name, setName] = useState('');
  const [province, setProvince] = useState('');
  const showPopup = useCallback(() => {
    setName(getRandom(NAMES));
    setProvince(getRandom(PROVINCES));
    setLeaving(false);
    setVisible(true);
    setTimeout(() => {
      setLeaving(true);
      setTimeout(() => {
        setVisible(false);
      }, 500);
    }, 4000);
  }, []);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, [showPopup]);
  useEffect(() => {
    if (!visible && name) {
      const nextTimeout = setTimeout(() => {
        showPopup();
      }, getRandomInterval());
      return () => clearTimeout(nextTimeout);
    }
  }, [visible, name, showPopup]);
  if (!visible) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-xs bg-white rounded-lg shadow-2xl border border-gold-500/30 overflow-hidden ${leaving ? 'animate-slide-out' : 'animate-slide-in'}`} data-id="element-303">
      <div className="p-4 flex items-start gap-3" data-id="element-304">
        <div className="flex-shrink-0 w-10 h-10 bg-gold-500 rounded-full flex items-center justify-center" data-id="element-305">
          <ShoppingCartIcon className="w-5 h-5 text-white" data-id="element-306" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-307">
          <p className="text-sm font-semibold text-gray-900 font-body" data-id="element-308">
            {name} de {province}
          </p>
          <p className="text-xs text-gray-600 font-body mt-0.5" data-id="element-309">
            acaba de comprar este curso 🔮
          </p>
          <p className="text-xs text-gray-400 font-body mt-1" data-id="element-310">
            Hace unos momentos
          </p>
        </div>
        <button onClick={() => {
        setLeaving(true);
        setTimeout(() => setVisible(false), 500);
      }} className="flex-shrink-0 text-gray-400 hover:text-gray-600" aria-label="Cerrar notificación" data-id="element-311">
          <XIcon className="w-4 h-4" data-id="element-312" />
        </button>
      </div>
      <div className="h-1 bg-gradient-to-r from-gold-500 to-gold-600" data-id="element-313" />
    </div>;
}